import { Props } from './types';

const defaultProps = {
  palette: 'default' as Props['palette'],
  size: 'medium' as Props['size'],
  variant: 'solid' as Props['variant'],
  flow: 'auto' as Props['flow'],
  type: 'button' as Props['type'],
  borderRadius: 'small' as Props['borderRadius'],
};

export default defaultProps;
